import React from 'react';

import { css, cx } from '@emotion/css';
import { Theme } from '@mui/material';
import { Link } from '@tanstack/react-router';

import { Icons } from '@/assets/icons';
import { useStyles } from '@/hooks/useStyles';

export type LogoProps = {
  to?: string;
  className?: string;
};

export const Logo: React.FC<LogoProps> = ({ to = '/', className }) => {
  const styles = useStyles(makeStyles);
  return (
    <Link to={to} id="app-logo" className={cx(styles.container, className)}>
      <Icons.logoRoundFull className={styles.img} />
    </Link>
  );
};

const makeStyles = (theme: Theme) => ({
  container: css`
    display: block;
    padding-top: ${theme.spacing(4)};
    justify-content: center;
    align-items: center;
    cursor: pointer;
  `,
  img: css`
    color: ${theme.palette.environment};
    width: 3rem;
    height: 3rem;
  `,
});
